import {i18n} from '@netx/core/i18n';

export const AttributeProfilesSystemLabel = {
	ROUTE: i18n.t('i18n.attributeProfiles'),
};

export const PROFILE_ACTION = <const>{
	ADD: i18n.t('i18n.addAttributeProfile'),
	EDIT: i18n.t('i18n.editAttributeProfile'),
};
